export default "__VITE_ASSET__ba132593__"